import {
  API_GET_SOURCE_RATING_TEMPLATE,
  API_GET_SOURCE_IMPORT_HISTORY,
  API_IMPORT_SOURCE_RATING_FILE,
  API_FETCH_COUNTRY_ISO_DICTIONARY,
} from "@/config/api.config";
import apiCall from "@/utils/api";
import downloadFile from "@/utils/file";

export const FETCH_SOURCE_RATING_IMPORT = "FETCH_SOURCE_RATING_IMPORT";
export const SET_SOURCE_RATING_IMPORT = "SET_SOURCE_RATING_IMPORT";
export const FETCH_SOURCE_RATING_TEMPLATE = "FETCH_SOURCE_RATING_TEMPLATE";
export const IMPORT_SOURCE_RATING_FILE = "IMPORT_SOURCE_RATING_FILE";
export const FETCH_COUNTRY_ISO_FILE = "FETCH_COUNTRY_ISO_FILE";

export default {
  [FETCH_SOURCE_RATING_IMPORT]({ commit }, { params } = {}) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    return apiCall({
      method: API_GET_SOURCE_IMPORT_HISTORY,
      params,
    })
      .then(({ status, data }) => {
        if (status === 200 && !data.error) {
          commit(SET_SOURCE_RATING_IMPORT, data);
          return data;
        }
        throw data;
      })
      .catch((error) => {
        commit("SET_ERROR", error.details || error.message);
        throw error;
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
  [FETCH_SOURCE_RATING_TEMPLATE]() {
    return new Promise((resolve, reject) => {
      return downloadFile({
        method: API_GET_SOURCE_RATING_TEMPLATE,
      }).then((response) => {
        let { status, data } = response;
        if (status === 200 && !data.error) {
          resolve(data);
        } else {
          reject(data);
        }
      });
    });
  },
  [IMPORT_SOURCE_RATING_FILE](context, { formData }) {
    return new Promise((resolve, reject) => {
      return apiCall({
        method: API_IMPORT_SOURCE_RATING_FILE,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      }).then((response) => {
        let { status, data } = response;
        if (status === 200 && !data.error) {
          resolve(data.data);
        } else {
          reject(data.details);
        }
      });
    });
  },
  [FETCH_COUNTRY_ISO_FILE]() {
    return downloadFile({
      method: API_FETCH_COUNTRY_ISO_DICTIONARY,
      params: { format: "excel" },
    });
  },
};
